import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-black text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img
              src="/divaisetech-logo.png"
              alt="DivaiseTech"
              className="h-9 w-auto mb-4"
            />
            <p className="text-white/80 mb-4">
              Focused on AI-based IT solutions and automations,
              hardware requirement fulfillment, and AI-based chips.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-white/80 hover:text-white transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/solutions"
                  className="text-white/80 hover:text-white transition-colors"
                >
                  Solutions
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-white/80 hover:text-white transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-white/80 hover:text-white transition-colors"
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="/digital-experience-platform-solutions"
                  className="text-white/80 hover:text-white transition-colors"
                >
                  AEM Development
                </Link>
              </li>
              <li>
                <Link
                  to="/it-hardware-solutions"
                  className="text-white/80 hover:text-white transition-colors"
                >
                  Hardware Solutions
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Services</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/solutions"
                  className="text-white/80 hover:text-accent transition-colors"
                >
                  All Solutions
                </Link>
              </li>
              <li>
                <Link
                  to="/digital-experience-platform-solutions"
                  className="text-white/80 hover:text-accent transition-colors"
                >
                  AEM Development Services
                </Link>
              </li>
              <li>
                <Link
                  to="/it-hardware-solutions"
                  className="text-white/80 hover:text-accent transition-colors"
                >
                  IT Hardware Solutions
                </Link>
              </li>
              <li>
                <Link
                  to="/free-aem-consultation"
                  className="text-white/80 hover:text-accent transition-colors"
                >
                  Free AEM Consultation
                </Link>
              </li>
              <li>
                <Link
                  to="/request-hardware-quote"
                  className="text-white/80 hover:text-accent transition-colors"
                >
                  Request Hardware Quote
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-white">Contact Us</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-1" />
                <p className="text-white/80">
                  13,14 Floor 4, SS Omnia Business Tower
                  <br />
                  Sector 85, Gurgaon
                </p>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 flex-shrink-0" />
                <a
                  href="tel:+918287934973"
                  className="text-white/80 hover:text-white transition-colors"
                >
                  8287934973
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 flex-shrink-0" />
                <a
                  href="mailto:consult@divaisetech.com"
                  className="text-white/80 hover:text-white transition-colors"
                >
                  consult@divaisetech.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/20 mb-8"></div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-white/70 text-sm mb-4 md:mb-0">
            © {new Date().getFullYear()} Divaise Technology Private Limited.
            All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
